<template>
  <div class="customization-box">

    <CustomizationBoxMain 
      :backToStep="backToStep"
    />
    <component 
      :is="customizationStepComponent" 
      :typeOfDecoration="typeOfDecoration"
      @return="handleReturn"
    />

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import CustomizationBoxMain from "@/components/Projects/Showrooms/CustomizationBox/CustomizationBoxMain"
import CustomizationStep1 from "@/components/Projects/Showrooms/CustomizationBox/CustomizationStep1.vue";
import CustomizationBoxDecoration from "@/components/Projects/Showrooms/CustomizationBox/CustomizationBoxDecoration.vue";
import LogoUploadBox from "@/components/Projects/Showrooms/CustomizationBox/LogoUploadBox.vue";

export default {
  name: 'CustomizationBox',
  computed: {

    ...mapState("showroom", ["customizationStep"]),

    customizationStepComponent() {
      switch (this.customizationStep) {
        
        case 'spiritwear-decorations':
        case 'uniform-decorations': {
          return 'CustomizationBoxDecoration'
        }
        case 'spiritwear-custom-logo':
        case 'uniform-custom-logo': {
          return 'LogoUploadBox'
        }

      }

      return 'CustomizationStep1'

    },

    typeOfDecoration() {
      return this.customizationStep.indexOf('spiritwear') > -1 ? 'spiritwear' : 'uniform'
    },

    backToStep() {
      switch (this.customizationStep) {
        case 'spiritwear-decorations': 
        case 'uniform-decorations':
        {
          return 'home'
        }
        case 'spiritwear-custom-logo': 
        {
          return 'spiritwear-decorations'
        }
        case 'uniform-custom-logo': 
        {
          return 'uniform-decorations'
        }
        default: {
          return 'home'
        }
      }
    }

  },

  methods: {
    
    ...mapActions("showroom", ["setCustomizationStep"]),
    
    handleReturn() {
      this.setCustomizationStep(this.backToStep)
    },

  },

  components: {
    CustomizationBoxMain, CustomizationStep1, CustomizationBoxDecoration, LogoUploadBox
  }
}
</script>

<style lang="scss">
  #app {
    .customization-box {
      position: absolute;
      left: -20px;
      top: 15px;
      width: 515px;
      z-index: 2;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 10px;
      background: #FFFFFF;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 6px;

      .customization-wizard-header {
        padding: 15px;
        font-weight: 500;
        font-size: 18px;
        line-height: 160%;
        color: #26262C;
        border-bottom: 1px solid #ECEDED;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
      }
    }
  }
</style>